import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_SymptomScreeningChecklist = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_SymptomScreeningChecklist' className='file-pdf-document'>
            <div className='file-template'>

                <p>
                    <b>Symptom Screening Checklist</b>
                </p>

                <p>
                    <span className='eleHeader'>Client Name:</span>
                    <input type='text' id='txtClientName' name='txtClientName' className='add-only' />
                </p>
                <p>
                    <b>Presenting Problems:</b>
                    Describe the problem(s) that brought you here today. Please check any of the symptoms that you are currently experiencing in the past 90 days:
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_1' name='cbPresentingProblems_1' className='add-only' value='PresentingProblems_1' />
                            Depression</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_2' name='cbPresentingProblems_2' className='add-only' value='PresentingProblems_2' />
                            Feeling Hopeless</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_3' name='cbPresentingProblems_3' className='add-only' value='PresentingProblems_3' />
                            Extreme Sadness</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_4' name='cbPresentingProblems_4' className='add-only' value='PresentingProblems_4' />
                            Feeling Tearful</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_5' name='cbPresentingProblems_5' className='add-only' value='PresentingProblems_5' />
                            Trouble Concentrating</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_6' name='cbPresentingProblems_6' className='add-only' value='PresentingProblems_6' />
                            Change in sleeping habits &nbsp;
                            <input type='radio' id='rbPresentingProblemsMoreOrLess_6More' name='rbPresentingProblemsMoreOrLess_6' className='add-only' value='More' /> more &nbsp;
                            <input type='radio' id='rbPresentingProblemsMoreOrLess_6Less' name='rbPresentingProblemsMoreOrLess_6' className='add-only' value='Less' /> less

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_7' name='cbPresentingProblems_7' className='add-only' value='PresentingProblems_7' />
                            Memory Problems</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_8' name='cbPresentingProblems_8' className='add-only' value='PresentingProblems_8' />
                            Lack of Energy</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_9' name='cbPresentingProblems_9' className='add-only' value='PresentingProblems_9' />
                            Change in Eating Habits</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_10' name='cbPresentingProblems_10' className='add-only' value='PresentingProblems_10' />
                            Weight Changes</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_11' name='cbPresentingProblems_11' className='add-only' value='PresentingProblems_11' />
                            Feeling Extreme Happiness</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_12' name='cbPresentingProblems_12' className='add-only' value='PresentingProblems_12' />
                            Change in Sexual Interest or Function</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_13' name='cbPresentingProblems_13' className='add-only' value='PresentingProblems_13' />
                            Unable to Relax</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_14' name='cbPresentingProblems_14' className='add-only' value='PresentingProblems_14' />
                            Problems Getting Along with Others</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_15' name='cbPresentingProblems_15' className='add-only' value='PresentingProblems_15' />
                            Lack of Enjoyment of Usual Activities</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_16' name='cbPresentingProblems_16' className='add-only' value='PresentingProblems_16' />
                            Feeling Stressed</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_17' name='cbPresentingProblems_17' className='add-only' value='PresentingProblems_17' />
                            Self-Esteem Problems</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_18' name='cbPresentingProblems_18' className='add-only' value='PresentingProblems_18' />
                            EasilyIrritated</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_19' name='cbPresentingProblems_19' className='add-only' value='PresentingProblems_19' />
                            Perfectionism</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_20' name='cbPresentingProblems_20' className='add-only' value='PresentingProblems_20' />
                            Feeling Guilty</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_21' name='cbPresentingProblems_21' className='add-only' value='PresentingProblems_21' />
                            Obsessions or Compulsion</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_22' name='cbPresentingProblems_22' className='add-only' value='PresentingProblems_22' />
                            Feeling Nervous</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_23' name='cbPresentingProblems_23' className='add-only' value='PresentingProblems_23' />
                            Feeling Fearful</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_24' name='cbPresentingProblems_24' className='add-only' value='PresentingProblems_24' />
                            Sudden Feeling of Panic</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_25' name='cbPresentingProblems_25' className='add-only' value='PresentingProblems_25' />
                            PhysicalComplaints of Pain</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_26' name='cbPresentingProblems_26' className='add-only' value='PresentingProblems_26' />
                            Missing work or Late for Work</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_27' name='cbPresentingProblems_27' className='add-only' value='PresentingProblems_27' />
                            FallingAsleep at Work/School</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_28' name='cbPresentingProblems_28' className='add-only' value='PresentingProblems_28' />
                            Hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_29' name='cbPresentingProblems_29' className='add-only' value='PresentingProblems_29' />
                            Truancy</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_30' name='cbPresentingProblems_30' className='add-only' value='PresentingProblems_30' />
                            School Grades Dropping
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_31' name='cbPresentingProblems_31' className='add-only' value='PresentingProblems_31' />
                            Leaves Class Without</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_32' name='cbPresentingProblems_32' className='add-only' value='PresentingProblems_32' />
                            Permission</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_33' name='cbPresentingProblems_33' className='add-only' value='PresentingProblems_33' />
                            Paranoid</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_34' name='cbPresentingProblems_34' className='add-only' value='PresentingProblems_34' />
                            Headaches</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_35' name='cbPresentingProblems_35' className='add-only' value='PresentingProblems_35' />
                            Aggressive</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_36' name='cbPresentingProblems_36' className='add-only' value='PresentingProblems_36' />
                            Unable to Follow Instructions</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_37' name='cbPresentingProblems_37' className='add-only' value='PresentingProblems_37' />
                            Cruel to Animals</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_38' name='cbPresentingProblems_38' className='add-only' value='PresentingProblems_38' />
                            Disrespectful</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_39' name='cbPresentingProblems_39' className='add-only' value='PresentingProblems_39' />
                            Thoughts of Suicide</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_40' name='cbPresentingProblems_40' className='add-only' value='PresentingProblems_40' />
                            Lies</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_41' name='cbPresentingProblems_41' className='add-only' value='PresentingProblems_41' />
                            Steals</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_42' name='cbPresentingProblems_42' className='add-only' value='PresentingProblems_42' />
                            Teases</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblems_43' name='cbPresentingProblems_43' className='add-only' value='PresentingProblems_43' />
                            Bullies</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPresentingProblemsSuspensions_30' name='cbPresentingProblemsSuspensions_30' className='add-only' value='PresentingProblemsSuspensions_30' />
                            Suspensions/Detentions
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











